document.addEventListener('DOMContentLoaded', () => {

    // Hook into WooCommerce found_variation event on the variation form
    const variationFormEl = document.querySelector('.variations_form');

    jQuery(variationFormEl).on('wc_variation_form', function(event, variation) {
        updateProductSelections();
    });

    // Variation logic
    let variationForm = document.querySelector('.product form.cart');
    let typeSelector = document.querySelectorAll('input[name="purovitalis_selector__type"]');
    let variationButtons = document.querySelector('.purovitalis_selector__buttons');

    if (variationForm === null) {
        return;
    }

    let isVariableProduct = variationForm.classList.contains('variations_form');

    let productID;
    let variationID;
    let addToCartText;

    if (typeSelector !== null) {
        [...typeSelector].forEach((e) => {
            e.addEventListener('change', function () {
                updateProductSelections();
            });
        });
    }

    if (variationButtons !== null) {
        [...variationButtons.querySelectorAll('input')].forEach((e) => {
            e.addEventListener('change', function () {
                updateProductSelections();
            });
        });
    }

    function updateProductSelections() {

        // Base assumes variable subscriptions
        let AddToCartField = document.querySelector('input[name="add-to-cart"]');
        let ProductField = document.querySelector('input[name="product_id"]');
        let VariationField = document.querySelector('input[name="variation_id"]');
        let type = document.querySelector('input[name="purovitalis_selector__type"]:checked');

        // Overwrite for simple subscriptions
        if (!isVariableProduct) {
            AddToCartField = document.querySelector('button[name="add-to-cart"]');
            ProductField = document.querySelector('button[name="add-to-cart"]');
        }


        if (variationButtons !== null && variationForm !== null) {
            let selectedVariation = variationButtons.querySelector('input:checked');

            if (selectedVariation === null && variationButtons.querySelectorAll('input').length === 1) {
                selectedVariation = variationButtons.querySelector('input');
            }

            if (selectedVariation !== null) {
                let selectedVariationValue = selectedVariation.value;

                if (variationForm.querySelector('select') !== null) {
                    variationForm.querySelector('select').value = selectedVariationValue;
                }

                jQuery(variationForm).trigger('change');
                jQuery(variationForm).trigger('woocommerce_variation_select_change');
                jQuery(variationForm).trigger('check_variations');
                jQuery(variationForm).trigger('woocommerce_update_variation_values');

                if (type) {

                    let productIDElem = document.querySelector('input[name="purovitalis_' + type.value + '_id"]');

                    if (productIDElem !== null) {
                        productID = productIDElem.getAttribute('value');
                    }

                    let variationIDElem = document.querySelector('input[name="purovitalis_' + type.value + '_variation_' + selectedVariationValue + '"]');

                    if (variationIDElem !== null) {
                        variationID = variationIDElem.getAttribute('value');
                    }

                    // Set Subscription Price
                    let subscriptionPriceElem = document.querySelector('input[name="purovitalis_subscription_variation_' + selectedVariationValue + '"]');
                    let subscriptionPrice = subscriptionPriceElem.dataset.price;
                    let subscriptionRegularPrice = subscriptionPriceElem.dataset.regularPrice;

                    let subscribePriceWrapperPrice = document.querySelector('.purovitalis_selector__subscribe__price__wrapper__price__price .price-field');
                    let subscribePriceWrapperRegular = document.querySelector('.purovitalis_selector__subscribe__price__wrapper__price__regular .price-field');

                    if (subscribePriceWrapperPrice !== null) {
                        subscribePriceWrapperPrice.innerHTML = subscriptionPrice;
                    }

                    if (subscribePriceWrapperRegular !== null) {
                        subscribePriceWrapperRegular.innerHTML = subscriptionRegularPrice;
                    }

                    if (subscriptionPriceElem.dataset.onsale === "1") {
                        document.querySelector('.purovitalis_selector__subscribe__price__wrapper__price__regular').style.display = 'inline';
                    } else {
                        document.querySelector('.purovitalis_selector__subscribe__price__wrapper__price__regular').style.display = 'none';
                    }

                    // Set description label
                    document.querySelector('.purovitalis_selector__subscribe__checkbox_label').innerHTML = subscriptionPriceElem.dataset.description;


                    if (variationID !== null && ProductField !== null && AddToCartField !== null) {

                        ProductField.setAttribute('value', productID);
                        AddToCartField.setAttribute('value', productID);
                        if (VariationField !== null) {
                            VariationField.setAttribute('value', variationID);
                        }

                        // Set One-Time Price
                        let oneTimePriceElem = document.querySelector('input[name="purovitalis_onetime_variation_' + selectedVariationValue + '"]');
                        if (oneTimePriceElem !== null) {
                            let oneTimePrice = oneTimePriceElem.dataset.price;
                            let oneTimeRegularPrice = oneTimePriceElem.dataset.regularPrice;
                            let oneTimePriceWrapper = document.querySelector('.purovitalis_selector__one-time__price__wrapper__price__price .price-field');
                            let oneTimePriceRegularWrapper = document.querySelector('.purovitalis_selector__one-time__price__wrapper__price__regular .price-field');

                            if (oneTimePriceElem.dataset.onsale === "1") {
                                document.querySelector('.purovitalis_selector__one-time__price__wrapper__price__regular').style.display = 'inline';
                            } else {
                                document.querySelector('.purovitalis_selector__one-time__price__wrapper__price__regular').style.display = 'none';
                            }

                            if (oneTimePriceWrapper !== null) {
                                oneTimePriceWrapper.innerHTML = oneTimePrice;
                            }
                            if (oneTimePriceRegularWrapper !== null) {
                                oneTimePriceRegularWrapper.innerHTML = oneTimeRegularPrice;
                            }
                        }
                    }

                    // Change Add To Cart Text
                    let AddToCartTextElem = document.querySelector('input[name="purovitalis_' + type.value + '_variation_' + selectedVariationValue + '"]');

                    if (AddToCartTextElem !== null) {
                        addToCartText = AddToCartTextElem.dataset.text;

                        let AddToCartButton = variationForm.querySelector('.single_add_to_cart_button');
                        AddToCartButton.classList.add('plausible-event-name=AddToCart');

                        if (AddToCartButton !== null) {
                            AddToCartButton.innerHTML = addToCartText;
                        }
                    }

                    // Update Sticky Bar
                    let wpcsb = document.querySelector('.wpcsb-wrapper');
                    if (wpcsb !== null) {
                        // Selected Price
                        let selectedPriceElem = document.querySelector('input[name="purovitalis_' + type.value + '_variation_' + selectedVariationValue + '"]');
                        if (selectedPriceElem !== null) {
                            let price = selectedPriceElem.dataset.price;
                            let regularPrice = selectedPriceElem.dataset.regularPrice;

                            let del = wpcsb.querySelector('.wpcsb-product-price .wpcsb-price-new del');
                            let ins = wpcsb.querySelector('.wpcsb-product-price .wpcsb-price-new ins');

                            if (del !== null) {
                                // Only show dell if they're different
                                if (price === regularPrice) {
                                    del.style.display = 'none';
                                } else {
                                    del.style.display = '';
                                }

                                // Update the price text node
                                del.innerHTML = regularPrice;
                            }

                            if (ins !== null) {
                                // Update the price text node
                                ins.innerHTML = price;
                            }

                            // Update add to cart text
                            let wpcsdbAddToCart = wpcsb.querySelector('.wpcsb-add-to-cart .button span');

                            if (wpcsdbAddToCart !== null) {
                                wpcsdbAddToCart.innerHTML = addToCartText;
                            }

                            let subscriptionDetailsElem = wpcsb.querySelector('.wpcsb-product-price .wpcsb-price-new .subscription-details');

                            if (subscriptionDetailsElem !== null) {
                                // Show/hide the monthly element
                                if (type.value === 'onetime') {
                                    subscriptionDetailsElem.style.display = 'none';
                                } else {
                                    subscriptionDetailsElem.style.display = 'inline';
                                }
                            }
                        }
                    }

                }

            }
        }
    }

});